import { render, staticRenderFns } from "./footlink.vue?vue&type=template&id=e73fdd88&scoped=true&"
import script from "./footlink.vue?vue&type=script&lang=js&"
export * from "./footlink.vue?vue&type=script&lang=js&"
import style0 from "./footlink.vue?vue&type=style&index=0&id=e73fdd88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73fdd88",
  null
  
)

export default component.exports